/*
 * サブシステム名：
 * 機能名：日報入力
 * 表示項目カスタマイズ(花巻運輸)
 */

import D2PRMD0021 from '@/views/PRM/D2PRMD0021.js'
// import filter from '@/rahmen/utils/filters'
import d2fmt from '@/ddv2.library/utils/formatter'
// import indexeddb from '@/ddv2.library/indexeddb'

export default ({
  extends: D2PRMD0021,
  name: 'NippoEditCustomForHNU',
  data: () => ({
    customJuchuRirekiHeaders: [
      { text: '', value: 'actions', align: 'center' },
      { text: '受注営業所', value: 'juchuEigyoshoNm' },
      { text: '荷主', value: 'tokuisakiNm' },
      { text: '発地', value: 'hatsuchiDisp' },
      { text: '着地', value: 'chakuchiDisp' },
      { text: '発地年月日', value: 'hatsuchiYmdDisp' },
      { text: '発地時刻', value: 'hatsuchiHmsDisp' },
      { text: '着地', value: 'chakuchiDisp' },
      { text: '着地年月日', value: 'chakuchiYmdDisp' },
      { text: '着地時刻', value: 'chakuchiHmsDisp' },
      { text: '商品', value: 'hinmeiDisp' },
      { text: '単価', value: 'tankaDisp' },
      { text: '数量', value: 'juchuSuryoDisp', align: 'end' },
      { text: '単位', value: 'unitKbnNm' },
      { text: '重量(t)', value: 'juchuJuryoDisp', align: 'end' },
      { text: '請求計上日', value: 'seikyuYoteiYmdDisp' },
      { text: '運賃計算区分', value: 'unchinKeisanKbnNm' },
      { text: '請求車種', value: 'seikyuShashuSbtNm' },
      { text: '運賃', value: 'kihonUnchinDisp', align: 'end' },
      { text: '高速道路料', value: 'unchinHokaKingakuDisp', align: 'end' },
      { text: 'その他非課税', value: 'unchinHokaHikazeiDisp', align: 'end' },
      { text: '待機時間', value: 'taikiJikanDisp', align: 'center' },
      { text: '待機時間単価', value: 'taikiJikanTankaDisp', align: 'end' },
      { text: '待機時間料', value: 'taikiJikanKingakuDisp', align: 'end' },
      { text: '割増金額(時間)', value: 'jikanWarimashiKingakuDisp', align: 'end' },
      { text: '割増金額(距離)', value: 'kyoriWarimashiKingakuDisp', align: 'end' },
      { text: '割増その他', value: 'warimashiSonotaKingakuDisp', align: 'end' },
      { text: '傭車額', value: 'yoshaKihonUnchinDisp', align: 'end' },
      { text: '傭車高速代', value: 'yoshaHiwayPriceDisp', align: 'end' },
      { text: '傭車その他課税', value: 'yoshaUnchinHokaKingakuDisp', align: 'end' },
      { text: '傭車その他非課税', value: 'yoshaUnchinHokaHikazeiDisp', align: 'end' },
      { text: '摘要', value: 'seikyuBiko' }
    ],
    customTeikeiCorseHeaders: [
      { text: '', value: 'actions', align: 'center' },
      { text: 'コースNo', value: 'teikeiCourseNo' },
      { text: 'コース名称', value: 'teikeiCourseNm' },
      { text: '荷主', value: 'tokuisakiNm' },
      { text: '発地', value: 'hatsuchiDisp' },
      { text: '発時刻', value: 'hatsuchiHmsDisp' },
      { text: '着地', value: 'chakuchiDisp' },
      { text: '着時刻', value: 'chakuchiHmsDisp' },
      { text: '商品', value: 'hinmeiDisp' },
      { text: '単価', value: 'tanka', align: 'end' },
      { text: '数量', value: 'juchuSuryo', align: 'end' },
      { text: '単位', value: 'unitKbnNm' },
      { text: '重量', value: 'juchuJuryo', align: 'end' },
      { text: '運賃計算方法', value: 'unchinKeisanKbnNm' },
      { text: '請求車種', value: 'seikyuShashuSbtNm' },
      { text: '運賃', value: 'kihonUnchin', align: 'end' },
      { text: '高速道路料', value: 'unchinHokaKingaku', align: 'end' },
      { text: 'その他非課税', value: 'unchinHokaHikazei', align: 'end' },
      { text: '待機時間', value: 'taikiJikanDisp', align: 'center' },
      { text: '待機時間単価', value: 'taikiJikanTanka', align: 'end' },
      { text: '待機時間料', value: 'taikiJikanKingaku', align: 'end' },
      { text: '時間割増金額', value: 'jikanWarimashiKingaku', align: 'end' },
      { text: '距離割増金額', value: 'kyoriWarimashiKingaku', align: 'end' },
      { text: '割増その他', value: 'warimashiSonotaKingaku', align: 'end' },
      { text: '請求金額合計', value: 'seikyuGokei', align: 'end' },
      { text: '摘要', value: 'seikyuBiko' },
      { text: '支払運賃', value: 'yoshaUnchin', align: 'end' },
      { text: '支払運賃(高速)', value: 'yoshaHiwayPrice', align: 'end' },
      { text: '支払その他課税', value: 'yoshaUnchinHokaKingaku', align: 'end' },
      { text: '支払その他非課税', value: 'yoshaUnchinHokaHikazei', align: 'end' },
      { text: '支払金額合計', value: 'shiharaiGokei', align: 'end' },
      { text: '支払用備考', value: 'shiharaiBiko' }
    ]
  }),
  computed: {
  },
  methods: {
    onCalcWithoutTax: function () {
      // 高速道路料から税分を減算
      let unchinHokaKingaku = this.recHaisoMeisai.unchinHokaKingaku || 0
      unchinHokaKingaku = d2fmt.removeComma(unchinHokaKingaku)
      const calcKingaku = Math.round(unchinHokaKingaku / 1.1)
      this.$set(this.recHaisoMeisai, 'unchinHokaKingaku', calcKingaku)
    }
  }
})
